import { OpenPayCard } from "@/interfaces/openPayCard";
import { defineStore } from "pinia";
import { ref, toRaw } from "vue";



export const useCompanyOpenPayCardsStore = defineStore('companyOpenPayCards', () => {
    const cards = ref<OpenPayCard[]>([])

    return {
        cards,

        setCards(value: OpenPayCard[]) {
            cards.value = toRaw(value);
        }
    }
});